module.exports = __webpack_public_path__ + "img/Logo-14.5b0ec5d4.svg";